/* eslint-disable @typescript-eslint/no-unused-vars */

import { Swiper } from 'swiper/bundle';

function updateSlideAccessibility(swiper) {
  swiper.slides.forEach((slide) => {

    const focusables = slide.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]'
    );

    const isDuplicate = slide.classList.contains('swiper-slide-duplicate');
    const isVisible = slide.classList.contains('swiper-slide-visible');

    if (isDuplicate || !isVisible) {

      slide.setAttribute('aria-hidden', 'true');

      focusables.forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });

    } else {

      slide.removeAttribute('aria-hidden');

      focusables.forEach((el) => {
        el.removeAttribute('tabindex');
      });
    }
  });
}

const accessibilityEvents = {
  init(swiper) {
    updateSlideAccessibility(swiper);
  },

  slideChange(swiper) {
    updateSlideAccessibility(swiper);
  },

  transitionEnd(swiper) {
    updateSlideAccessibility(swiper);
  },
};

const accessibilityOptions = {
  enabled: true,
};

const keyboardOptions = {
  enabled: true,
  onlyInViewport: true,
};

var text_image_slider = new Swiper('.text-image-slider', {
  loop: false,
  slidesPerView: 1,

  keyboard: keyboardOptions,
  a11y: accessibilityOptions,
  on: accessibilityEvents,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.slider-text-image-next',
    prevEl: '.slider-text-image-prev',
  },
});

var cards_team_slider = new Swiper('.cards-team-slider', {
  loop: false,
  slidesPerView: 'auto',
  centeredSlides: false,
  spaceBetween: 18,

  keyboard: keyboardOptions,
  a11y: accessibilityOptions,
  on: accessibilityEvents,

  navigation: {
    nextEl: '.cards-team-next',
    prevEl: '.cards-team-prev',
  },
});

var images_slider = new Swiper('.images-slider', {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 18,

  keyboard: keyboardOptions,
  a11y: accessibilityOptions,
  on: accessibilityEvents,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.images-slider-next',
    prevEl: '.images-slider-prev',
  },

  breakpoints: {
    992: {
      spaceBetween: 20,
    },

    1400: {
      spaceBetween: 200,
    },
  },
});

var cards_slider = new Swiper('.cards-slider', {
  loop: true,

  slidesPerView: 1.1,
  centeredSlides: true,
  spaceBetween: 12,

  keyboard: keyboardOptions,
  a11y: accessibilityOptions,
  on: accessibilityEvents,

  navigation: {
    nextEl: '.slider-cards-next',
    prevEl: '.slider-cards-prev',
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {

    768: {
      centeredSlides: false,
      slidesPerView: 1.5,
      spaceBetween: 32,
    },

    992: {
      centeredSlides: false,
      slidesPerView: 1.7,
      spaceBetween: 38,
    },

    1200: {
      centeredSlides: false,
      slidesPerView: 1.5,
      spaceBetween: 38,
    },

    1800: {
      centeredSlides: false,
      slidesPerView: 1.8,
      spaceBetween: 38,
    },

    1920: {
      centeredSlides: false,
      slidesPerView: 2,
      spaceBetween: 38,
    },
  },
});

var related_articles = new Swiper('.related-articles-swiper', {
  loop: false,
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 16,

  keyboard: keyboardOptions,
  a11y: accessibilityOptions,
  on: accessibilityEvents,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  breakpoints: {

    1400: {
      enabled: false,
      spaceBetween: 0,
    },
  },
});

/* eslint-enable @typescript-eslint/no-unused-vars */